<template>
  <div style="width:100%" class="container">
    <azour-header-child
      :viewType="true"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant"
    />

    <azour-body-child
      :viewType="true"
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
      :newSection="newSection"
      :listSections="listSections"
      :currentTab="currentTab"
      :setCurrentTab="setCurrentTab"
      :handleChangeShowSub="handleChangeShowSub"
      :disponibleItem="disponibleItem"
      :showItem="showItem"
      :currentCurrency="currentCurrency"
      :selectedLangues="selectedLangues"
      :addToCart="addToCart"
      :selectes_ids="selectes_ids"
    />
    <azour-footer-child
      :currentLang="currentLang"
      :restaurant="restaurant ? restaurant : {}"
    />
  </div>
</template>

<script>
import azourHeader1 from "../headers/azour.vue";
import azourBody1 from "../body/azour.vue";
import azourFooter1 from "../footer/azour.vue";
export default {
  components: {
    "azour-header-child": azourHeader1,
    "azour-body-child": azourBody1,
    "azour-footer-child": azourFooter1,
  },
  props: [
    "changeName",
    "currentLang",
    "newItem",
    "restaurant",
    "newSection",
    "listSections",
    "currentTab",
    "setCurrentTab",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "currentCurrency",
    "selectedLangues",
    "addToCart",
    "selectes_ids",
  ],
  data() {
    return {};
  },
  methods: {},
  watch: {},
};
</script>

<style>
.azour-theme-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
